export default {
    title: '需求詳情'
}
